import { z } from "zod";

const REG_PHONE_10_DIGITS = /^0\d{9}$/;
const REG_PHONE_11_DIGITS = /^0\d{10}$/;

type ValidatorSchemaType = {
  username: z.ZodString;
  phone: {
    [key: number]: z.ZodString;
  };
  otp: z.ZodString;
  legalName: z.ZodString;
  payment: {
    accountNo: {
      [key: number]: z.ZodString;
    };
    accountType: z.ZodString;
    isDefault: z.ZodOptional<z.ZodBoolean>;
  };
  loginPassword: z.ZodString;
  loginPin: z.ZodString;
  registerPassword: z.ZodString;
};

export const ValidatorSchema: ValidatorSchemaType = {
  username: z
    .string()
    .min(4, "4-13 alphanumeric without special character.")
    .max(13, "4-13 alphanumeric without special character.")
    .regex(/^\w+$/, "only letters, numbers, and underscores (_) are allowed."),
  loginPassword: z.string().min(8, "at least 8 characters with letters & numbers"),
  loginPin: z.string().min(4, "PIN length is invalid"),
  registerPassword: z
    .string()
    .min(8, "at least 8 characters with letters & numbers")
    .regex(/^(?=.*[A-Za-z])(?=.*\d).+$/, "at least 8 characters with letters & numbers")
    .regex(/^\S+$/, "spaces are not allowed"),
  phone: {
    "10": z
      .string()
      .regex(/^0/, "phone number should start with 0")
      .regex(REG_PHONE_10_DIGITS, "Phone number must be 10 digits"),
    "11": z
      .string()
      .regex(/^0/, "enter a 11-digit number starting with 0")
      .regex(REG_PHONE_11_DIGITS, "enter a 11-digit number starting with 0"),
  },
  otp: z.string().min(1, "otp is required. click on get code"),
  legalName: z.string().min(1, "required"),
  payment: {
    accountNo: {
      "10": z
        .string({
          required_error: "required",
        })
        .min(1, "required")
        .regex(/^0/, "enter a 10-digit number starting with 0")
        .regex(REG_PHONE_10_DIGITS, "enter a 10-digit number starting with 0"),
      "11": z
        .string({
          required_error: "required",
        })
        .min(1, "required")
        .regex(/^0/, "enter a 11-digit number starting with 0")
        .regex(REG_PHONE_11_DIGITS, "enter a 11-digit number starting with 0"),
    },
    accountType: z
      .string({
        required_error: "required",
      })
      .min(1, "required"),
    isDefault: z.boolean().optional(),
  },
};
